import SsoCallback from './SsoCallback';

export default SsoCallback;
